import { render, staticRenderFns } from "./SchoolAdministrator.vue?vue&type=template&id=1934ddb5&scoped=true&"
import script from "./SchoolAdministrator.vue?vue&type=script&lang=js&"
export * from "./SchoolAdministrator.vue?vue&type=script&lang=js&"
import style0 from "./SchoolAdministrator.vue?vue&type=style&index=0&id=1934ddb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934ddb5",
  null
  
)

export default component.exports